<!-- jb-color-picker = 'jb-color-picker' -->

<h2>{{name}}</h2>
<hr/>
<p>{{desc}}</p>

<div class="whiteBg">
  <h5 class="mt-4">Parameters:</h5>
  <div class="col-12"><pre>{{api}}</pre></div>
</div>

<h5 class="mt-4">Examples:</h5>
<div class="col-12 examples-table">

  <div class="row">
    <div class="col-3">
      <jb-input
        [(ngModel)]="colorValue"
        jbLabel="Color Value"
        [jbIcon]="(compConf.hasIcon ? compConf.inputIcon : '')"
        [jbType]="compConf.inputType"
      ></jb-input>
      <jb-color-picker [(jbColor)]="colorValue"></jb-color-picker>
    </div>
    <div class="col-7">
      <pre>{{instance}}</pre>
    </div>
  </div>
</div>



<!--CSS Styling-->
<div class="row marT40">
  <div class="col-12">
    <hr>
    <h4>CSS Styling</h4>
    <p>The encapsulated styles of the button use a default color. However, we may want to apply different colors externally (depending on the theme)
      <br/>
      To provide a color restyiling based on a SCSS theme you can apply the following rules on a css global level :
    </p>
    <pre>{{ cssReset }}</pre>
  </div>
</div>

